// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; // ✅ Import Auth
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const fireConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_CUSTOMER_STORE_KEY,
  authDomain: "customers-50414.firebaseapp.com",
  projectId: "customers-50414",
  storageBucket: "customers-50414.firebasestorage.app",
  messagingSenderId: "998992470962",
  appId:process.env.REACT_APP_FIREBASE_CUSTOMER_STORE_ID
};


// Initialize Firebase
const custApp = getApps().find(app => app.name === 'customers') ||
  initializeApp(fireConfig, 'customers');
export const custDb = getFirestore(custApp);
export const userAuth = getAuth(custApp);